import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  ecSuiFrensWrapper: {
    minHeight: "100vh",
    "& .disable": {
      opacity: "0.6",
      pointerEvents: "none",
      filter: "grayscale(1)",
      cursor: "no-drop",
    },
    "& .topWrapper": {
      padding: "10px 0",
      backgroundColor: "var(--sPrimary)",
      color: "var(--black)",
    },
    "& .container": {
      maxWidth: "1140px",
      padding: "0 20px",
      margin: "0 auto",
    },
    "& .headerWrapper": {
      padding: "10px 30px",
      boxShadow: "0px 4px 20px 0px var(--blackOpacity10)",
      "& .logo": {
        "& img": {
          width: "100%",
          maxWidth: "100%",
          height: "50px"
        },
      },
      "& .basket-icon.active": {
        position: "relative",
        cursor: "pointer",
        "& .ePNum": {
          backgroundColor: "var(--sPrimary)",
          width: "15px",
          height: "15px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "8px",
          borderRadius: "50%",
          color: "var(--black)",
          fontWeight: "bold",
          position: "absolute",
          right: "-8px",
          bottom: "0px",
        },
      },
      "& .disable": {
        "& .ePNum": {
          display: "none",
        },
      },
    },
    "& .bannerSection": {
      "& .bBg": {
        padding: "50px 0",
        "& img": {
          width: "672px",
          maxWidth: "100%",
        },
      },
    },
    "& .productSection": {
      padding: "50px 0 100px",
      "& .pHeader": {
        "& .left": {
          "& .pHeading": {
            fontFamily: '"Frankfurter Std Regular", sans-serif!important',
            fontWeight: "400",
          },

          "& .pText": {
            color: "var(--blackOpacity75)",
          },
        },
        "& .right": {
          "& .ant-space": {
            border: "1px solid var(--black)",
            padding: "10px",
            display: "flex",
            width: "206px",
            justifyContent: "space-between",
            borderRadius: "5px",
            color: "var(--black)",
            "& .ant-space-item": {
              fontWeight: 600,
            },
            "& svg path": {
              fill: "var(--black)",
            },
          },
        },
      },
      "& .pBody": {
        marginTop: "50px",
        "& .pCard": {
          position: "relative",
          "& .pCardHeader": {
            overflow: "hidden",
            width: "100%",
            height: "343px",
            border: "2px solid var(--black)",
            boxShadow: "0 0 0 8px var(--sSecondary), 0 0 0 10px var(--black)",
            borderRadius: "12px",
            position: "relative",
            "& img": {
              transition: "0.4s all ease-in-out",
            },
            "& .stock": {
              position: "absolute",
              bottom: "20px",
              left: "20px",
              padding: "6px 12px",
              backgroundColor: "var(--black)",
              borderRadius: "5px",
              "& p": {
                color: "var(--white)",
                fontWeight: "500",
              },
            },
          },
          "& .pCardBody": {
            "& .pCardTitle": {
              transition: "0.4s all ease-in-out",
              fontFamily: '"Frankfurter Std Regular", sans-serif!important',
              fontWeight: "400",
              cursor: "pointer",
            },
          },
          "& .pCardFooter": {
            "& p": {
              color: "var(--danger)",
            },
          },
          "&:hover": {
            "& img": {
              transform: "scale(1.15)",
            },
            "& .pCardTitle": {
              textDecoration: "underline",
            },
          },
        },
      },
    },
    "& .exfooterWrapper": {
      backgroundColor: "var(--sTernary)",
      padding: "50px 0 30px",
      position: "relative",
      "& .footerLogo": {
        "& img": {
          width: "100%",
          maxWidth: "480px",
        },
      },
      "& p": {
        fontWeight: "normal",
        lineHeight: "29px",
        color: "var(--blackOpacity75)",
        "& span": {
          borderBottom: "1px solid var(--black)",
          fontWeight: "bold",
          "&:hover": {
            borderBottom: "2px solid var(--black)",
            fontWeight: "bold",
            color: "var(--black)",
          },
        },
      },
      "& .socialIcons": {
        paddingBottom: "50px",
        "& span": {
          "& svg": {
            transition: "0.3s all ease-in-out",
            "&:hover": {
              transform: "scale(1.1)",
              opacity: "0.75",
            },
          },
        },
      },
      "& .quickLinks": {
        width: "100%",
        paddingTop: "30px",
        borderTop: "1px solid var(--blackOpacity10)",
        "& li": {
          listStyle: "none",
          position: "relative",
          "&:before": {
            content: `""`,
            position: "absolute",
            top: "10px",
            left: "-15px",
            backgroundColor: "var(--black)",
            width: "3px",
            height: "3px",
            borderRadius: "50%",
            opacity: "0.25",
          },
          "& a": {
            textDecoration: "unset",
            color: "var(--blackOpacity75)",
            transition: "0.2s all ease-in-out",
            "&:hover": {
              textDecoration: "underline",
              color: "var(--black)",
            },
          },
          "&:first-child": {
            "&:before": {
              display: "none",
            },
          },
        },
      },
    },
    "& .singleProductSection": {
      "& .left": {
        position: "relative",
        borderRadius: "20px",
        height: "100%",
        backgroundColor: "var(--light)",
      },
      "& .right": {
        "& .stock": {
          padding: "6px 12px",
          backgroundColor: "var(--black)",
          borderRadius: "5px",
          "& p": {
            color: "var(--white)",
            fontWeight: "500",
          },
        },
        "& .pCardTitle": {
          fontSize: "32px",
          fontFamily: '"Frankfurter Std Regular", sans-serif!important',
          fontWeight: "400",
          outline: "1px solid var(--white)",
        },
        "& .pCardContent": {
          color: "var(--blackOpacity75)",
        },
        "&  .pCardQuantity": {
          "&  p": {
            color: "var(--blackOpacity75)",
          },
          "&  .pCardQuantityBtn": {
            padding: "12px 30px",
            borderRadius: "5px",
            border: "1px solid var(--black)",
            "& button": {
              background: "transparent",
              border: "none",
              boxShadow: "none",
              fontSize: "20px",
              color: "var(--black)",
              lineHeight: "0",
              padding: "0",
              "&:hover": {
                backgroundColor: "transparent!important",
                color: "unset!important",
                boxShadow: "none!important",
              },
            },
          },
        },
      },
    },
  },
});
